import React from "react";
import "gantt-task-react/dist/index.css";
import { ViewMode } from "gantt-task-react";


export const ViewSwitcher = ({
    
  onViewModeChange,
  onViewListChange,
  isChecked


}) => {
  return (
    <div className="ViewContainer py-2">
      {/* <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.QuarterDay)}
      >
        Quarter of Day
      </button> */}

      {/* <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.HalfDay)}
      >
        Half of Day
      </button> */}


      <button className="Button" onClick={() => onViewModeChange(ViewMode.Day)}>
        Day
      </button>

      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Week)}
      >
        Week
      </button>

      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Month)}
      >
        Month
      </button>

      <div className="Switch">
        <label className="Switch_Toggle">
          <input
            type="checkbox"
            defaultChecked={isChecked}
            onClick={() => onViewListChange(!isChecked)}
          />
          <span className="Slider" />
        </label>
        Show Task List
      </div>

    </div>
  );
};
